import React from 'react';

import { Button } from '@mui/material';

import { CHALLENGE_STATUS, ChallengeStatusType } from '../../constants/challengeStatus';
import { useModalToggle } from '../../../shared/hooks/useModalToggle';
import { JoinToChallengeModal } from './JoinToChallengeModal/JoinToChallengeModal';

type JoinChallengeButtonProps = {
  challengeId: string;
  challengeStatus: ChallengeStatusType;
  isRegistrationPeriod: boolean;
};

const JoinChallengeButton = ({
  challengeId,
  challengeStatus,
  isRegistrationPeriod,
}: JoinChallengeButtonProps) => {
  const [joinToChallengeModalOpen, toggleJoinToChallengeModal] = useModalToggle(false);

  const isButtonHidden =
    challengeStatus === CHALLENGE_STATUS.FINISHED ||
    (challengeStatus === CHALLENGE_STATUS.ACTIVE && !isRegistrationPeriod);

  const isButtonDisabled =
    challengeStatus === CHALLENGE_STATUS.DRAFT ||
    (challengeStatus === CHALLENGE_STATUS.PUBLISHED && !isRegistrationPeriod);

  if (isButtonHidden) {
    return null;
  }

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        disabled={isButtonDisabled}
        onClick={toggleJoinToChallengeModal}
      >
        Join the Challenge
      </Button>
      <JoinToChallengeModal
        challengeId={challengeId}
        open={joinToChallengeModalOpen}
        onClose={toggleJoinToChallengeModal}
      />
    </>
  );
};

export { JoinChallengeButton };
